<div class="reviews-outer">
  <h2 class="trinidad-bold">Become a caretaker for {{ (boondock$ | async)?.name }}.</h2>
  <p class="wizard-paragraph _12px">
    Caretaker provides additional information to the government sites. If you see &ldquo;Teddy R&rdquo; then it&rsquo;s
    a site that where the guest can become the &ldquo;caretaker&rdquo; The caretaker would need to provide a picture of
    the site (we recommend three), ensure site details are current and accurate.
  </p>
  <p class="wizard-paragraph">
    <strong>What are the benefits of being the caretaker?</strong> You can get up to 50% of any future donations and
    you're helping future boondockers.
  </p>
  <div class="caretaker-outer">
    <div class="center">
      <div class="user-image reviews">
        <img src="/img/President_Roosevelt_Avatar.jpg" alt="Teddy R. Avatar" class="user-image reviews" />
      </div>
      <div class="w-hidden-small w-hidden-tiny">Teddy R.</div>
    </div>
    <div class="double-arrow">
      <div class="w-embed center">
        <svg
          width="128px"
          height="58px"
          viewBox="0 0 128 58"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="temp" fill="#E3530D" fill-rule="nonzero">
              <path
                d="M97.4,11.6 L119.4,29 L97.4,46.4 L97.4,43.5 L97.4,38.6666667 L91.4,38.6666667 L73.2,38.6666667 L55,38.6666667 L36.8,38.6666667 L30.8,38.6666667 L30.8,43.5 L30.8,46.4 L8.6,29 L30.6,11.6 L30.6,14.5 L30.6,19.3333333 L36.6,19.3333333 L54.8,19.3333333 L73,19.3333333 L91.2,19.3333333 L97.2,19.3333333 L97.2,14.5 L97.2,11.6 M91.4,0 L91.4,14.5 L73.2,14.5 L55,14.5 L36.8,14.5 L36.8,0 L0,29 L36.6,58 L36.6,43.5 L54.8,43.5 L73,43.5 L91.2,43.5 L91.2,58 L128,29 L91.4,0 L91.4,0 Z"
                id="Shape"
              ></path>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="center">
      <img
        *ngIf="isOnline"
        [src]="getAvatarPhoto((currentUser$ | async)?.photo)"
        alt="Site Host Profile Photo"
        class="user-image"
      />
      <ion-icon *ngIf="!isOnline" name="person-circle" class="user-image" style="color: #999999"></ion-icon>
      <div class="w-hidden-small w-hidden-tiny">
        {{ (currentUser$ | async)?.firstName }}
        {{ (currentUser$ | async)?.lastName }}
      </div>
    </div>
  </div>
  <div class="button-large-wrapper video">
    <a class="button trinidad center w-button" (click)="onBecomeCaretaker()">Become a Caretaker</a>
  </div>
  <div class="skip" *ngIf="!appContext">
    <a role="button" (click)="onSkip()">Skip</a>
  </div>
</div>
